import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {IoniconsOutline, NavItem, SessionInfoType, SessionNotification} from '@pt/pt-models';
import {PtCoreActions, PtCoreSelectors} from '@pt/pt-core';
import {Store} from '@ngrx/store';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {animate, AnimationEvent, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'pt-navbar-session-notification-item',
  animations: [
    trigger('badge', [
      state('static', style({
        backgroundColor: 'transparent'
      })),
      state('animate-red', style({
        backgroundColor: '#ffc107'
      })),
      state('animate-white', style({
        backgroundColor: 'white'
      })),
      transition('static <=> *', [
        animate('.7s')
      ]),
      transition('animate-red <=> animate-white', [
        animate('.7s')
      ])
    ])
  ],
  template: `
    <!--    [@badge]="state"-->
    <!--    (@badge.done)="showNext($event)"-->
    <div [ngClass]='containerClassCss'
         class='pt-navbar-session-notification-item cursor-pointer'
         [ngbTooltip]='item?.label | async' [openDelay]="800" [disableTooltip]="!item?.tooltipEnabled"
         (click)='isOpen ? closeSessionInfo() : openSessionInfo()'>

      <pt-icon [ngClass]='iconClassCss' [key]='IconAlarm' class='cursor-pointer'></pt-icon>

      <span class='badge rounded-pill badge-top'
            [ngClass]='badgeClassCss' *ngIf='downloadSessionNotification?.length > 0'>
        {{ downloadSessionNotification?.length }}
      </span>
    </div>
  `,
  styles: [`

    .pt-navbar-session-notification-item {
      position: relative;
      text-align: center;
      display: inline-flex !important;
      height: 50px;
      width: 50px;
      margin: 0;
      align-items: center;
      justify-content: center;
    }

    .pt-navbar-session-notification-item:hover {
      background: #00000044
    }

    .pt-navbar-session-notification-item pt-icon {
      font-size: 18px;
    }

    .badge-top {
      position: absolute;
      top: 5px;
      right: 3px;
    }

    .pt-text-primary {
      color: #3f51b5!important;
    }
  `]
})
export class NavbarSessionNotificationItemComponent implements OnInit, OnDestroy, OnChanges {
  public sessionInfo$ = this.store.select(PtCoreSelectors.sessionNotifications);
  public isOpenSessionInfo$ = this.store.select(PtCoreSelectors.isOpenSessionInfo);

  state: 'static' | 'animate-red' | 'animate-white' = 'static';
  animationStep = 0;
  animationRepeat = 6;
  isOpen: boolean;
  IconAlarm = IoniconsOutline.alarm;
  IconAlarmOff = IoniconsOutline.alarmOff;
  containerClassCss: string[];
  badgeClassCss: string[];
  iconClassCss: string[];

  @Input() item: NavItem;


  downloadSessionNotification: SessionNotification[];
  private destroy$ = new Subject<boolean>();

  constructor(private store: Store) {
  }

  static isChangeNotification(nt1: SessionNotification[], nt2: SessionNotification[]): boolean {
    return JSON.stringify(nt1) !== JSON.stringify(nt2);
  }

  showNext(event: AnimationEvent) {
    if (event.toState !== 'static') {
      setTimeout(() => {
        this.animationStep++;
        if (this.animationStep > this.animationRepeat) {
          this.state = 'static';
          this.animationStep = 0;
        } else {
          this.state = this.state === 'animate-red' ? 'animate-white' : 'animate-red';
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateClassCss();
  }

  ngOnInit(): void {
    this.sessionInfo$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((sessionInfo: SessionNotification[] | undefined) => {
      this.downloadSessionNotification = sessionInfo?.filter((d) => d.actionType === SessionInfoType.DOWNLOAD);
    });


    this.isOpenSessionInfo$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((isOpen) => {
      this.isOpen = isOpen;
      this.updateClassCss();
    });
  }

  openSessionInfo() {
    this.store.dispatch(PtCoreActions.openSessionNotifications());
  }

  closeSessionInfo() {
    this.store.dispatch(PtCoreActions.closeSessionNotifications());
  }

  private updateClassCss() {
    this.badgeClassCss = [];
    this.containerClassCss = this.item?.classCss ? this.item?.classCss : [];
    if (this.isOpen) {
      this.iconClassCss = ['pt-text-primary'];
      this.containerClassCss.push('pt-text-primary');
      this.containerClassCss.push('bg-white');
      if (this.downloadSessionNotification && this.downloadSessionNotification.length > 0) {
        this.badgeClassCss.push('bg-danger');
        this.badgeClassCss.push('text-light');
      } else {
        this.badgeClassCss.push('bg-primary');
        this.badgeClassCss.push('text-white');
      }
    } else {
      this.iconClassCss = ['text-light'];
      if (this.downloadSessionNotification && this.downloadSessionNotification.length > 0) {
        this.badgeClassCss.push('bg-danger');
        this.badgeClassCss.push('text-light');
      } else {
        this.badgeClassCss.push('bg-light');
        this.badgeClassCss.push('text-dark');
      }

    }


  }


}
